import API from './API.js';
export default class MasterAnnouncements extends API {
    constructor() {
        super('masterAnnouncements');
    }

}
